// extracted by mini-css-extract-plugin
export default {"item":"MobileCartOptionItem_item__luz3O","title":"MobileCartOptionItem_title__vELTW","info":"MobileCartOptionItem_info__gmNsS","cost":"MobileCartOptionItem_cost__z7Imv"};